export default __webpack_public_path__ + "static/media/jewelry1.0158f5e8.jpg";